import { getAuth } from "../common/Helpers";
import { PARAM_NAME_TOKEN } from "../configurations/strings.config";

const token = JSON.parse(getAuth(PARAM_NAME_TOKEN));

const initialState = {
  token: token ? { isLoggedIn: true, token } : { isLoggedIn: false, token: null },
  isLoggedIn: false,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default authReducer;